import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SLATE, INDIGO } from "../../constants/Colors";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "calc(100vh - 80px)",
        width: "calc(100% + 64px)",
        mx: "-32px",
        mt: "-24px",
        gap: 2,
        px: 3,
        textAlign: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: 96,
          fontWeight: 700,
          lineHeight: 1,
          color: SLATE[200],
          letterSpacing: "-4px",
          userSelect: "none",
        }}
      >
        404
      </Typography>

      <Typography
        variant="h5"
        sx={{ fontWeight: 600, color: SLATE[900], mt: 1 }}
      >
        Page not found
      </Typography>

      <Typography
        variant="body2"
        sx={{ color: SLATE[500], maxWidth: 340, lineHeight: 1.6 }}
      >
        The page you're looking for doesn't exist or may have been moved. Check
        the URL or navigate back to a known page.
      </Typography>

      <Button
        variant="contained"
        onClick={() => navigate(-1)}
        sx={{
          mt: 2,
          textTransform: "none",
          fontWeight: 500,
          backgroundColor: INDIGO[600],
          "&:hover": { backgroundColor: INDIGO[700] },
          borderRadius: "8px",
          px: 3,
        }}
      >
        Go back
      </Button>
    </Box>
  );
}
